import React from 'react';
import { AUTHORIZATION_STATUSES } from 'src/common/Status/authorizationConstants';
import ServiceAuthorizationWorkqueue from './ServiceAuthorizationWorkqueue';

const VoidedServiceAuthorizations = () => (
  <ServiceAuthorizationWorkqueue
    authorizationStatus={AUTHORIZATION_STATUSES.void}
  />
);

export default VoidedServiceAuthorizations;
